import React from 'react';
import { useTranslation } from 'react-i18next';

const ScoreTabNavigation = ({ activeTab, setActiveTab }) => {
  const { t } = useTranslation();
  return (
    <div className="score-tabs-navigation">
      <button
        className={`tab ${activeTab === 'global' ? 'active' : ''}`}
        onClick={() => setActiveTab('global')}
      >
        {t('Score Global')}
      </button>
      <button
        className={`tab ${activeTab === 'seo' ? 'active' : ''}`}
        onClick={() => setActiveTab('seo')}
      >
        {t('Score SEO')}
      </button>
      <button
        className={`tab ${activeTab === 'ux' ? 'active' : ''}`}
        onClick={() => setActiveTab('ux')}
      >
        {t('Score UX')}
      </button>
    </div>
  );
};

export default ScoreTabNavigation;
